export default __webpack_public_path__ + "static/media/complainIcon1.ed7b0687.webp";